import * as React from 'react';
import moment from 'moment';
import { ToolOutlined, DollarOutlined, ProfileOutlined } from '@ant-design/icons';
import DeliverableStatusDisplay from '../deliverable_status_display/DeliverableStatusDisplay';
import { UserNameWithEmail } from '../name_component/user/UserNameWithEmail';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	formatCurrency,
	workOrderMetricsTotal,
	workOrdersDoneCount,
} from '../../utils/DeliverableUtils';
import { cn } from '../../utils/ClassNamesUtils';

const DeliverableListItem = ({ deliverable, currency, selected, onClick }) => {
	const fmt = (amount) => (currency ? currency.symbolFormat(amount, 0) : formatCurrency(amount));
	const status = nullSafeGet('status', deliverable);
	const workOrderMetrics = nullSafeGet('workOrderMetrics', deliverable);
	const taskMetrics = nullSafeGet('taskMetrics', deliverable);
	const budget = nullSafeGet('budget', deliverable);
	const budgetUsed = nullSafeGet('budgetUsed', deliverable);
	const dueDate = nullSafeGet('dueDate', deliverable);
	const assignedTo = nullSafeGetOrElse('assignedTo', deliverable, []);
	const overBudget = budget != null && budgetUsed != null && budgetUsed > budget;

	return (
		<div
			onClick={onClick}
			className={`cursor-pointer border-0 border-l-2 border-solid px-6 py-3 ${
				selected ? 'border-owgray bg-owgray' : 'border-transparent hover:bg-grey-2'
			}`}
		>
			<div className="mb-2 flex items-center justify-between">
				<div className="flex items-center gap-2">
					<DeliverableStatusDisplay status={status} />
					{dueDate ? (
						<span className="footnoteregular text-character-secondary">
							Due: {moment(dueDate).format('M/D')}
						</span>
					) : null}
				</div>
				{assignedTo.length ? (
					<span className="footnoteregular text-character-secondary">
						<UserNameWithEmail email={assignedTo[0]} mode="inline" />
					</span>
				) : null}
			</div>
			<div className="bodyregular mb-2 text-character-primary">
				{nullSafeGet('name', deliverable)}
			</div>
			<div className="footnoteregular flex flex-wrap items-center gap-x-4 text-character-secondary">
				{workOrderMetrics ? (
					<span className="flex items-center gap-1">
						<ToolOutlined className="text-[12px]" />
						<span className="footnoteMedium text-character-primary">
							{workOrdersDoneCount(workOrderMetrics)}/{workOrderMetricsTotal(workOrderMetrics)}
						</span>
					</span>
				) : null}
				{budget != null ? (
					<span className="flex items-center gap-1">
						<DollarOutlined className="text-[12px]" />
						<span
							className={cn('footnoteMedium text-character-primary', {
								'text-sunsetOrange-8': overBudget,
							})}
						>
							{fmt(budgetUsed != null ? budgetUsed : 0)} / {fmt(budget)}
						</span>
					</span>
				) : null}
				{taskMetrics ? (
					<span className="flex items-center gap-1">
						<ProfileOutlined className="text-[12px]" />
						<span className="footnoteMedium text-character-primary">
							{nullSafeGetOrElse('tasksCompleted', taskMetrics, 0)}/
							{nullSafeGetOrElse('tasksTotal', taskMetrics, 0)}
						</span>
					</span>
				) : null}
			</div>
		</div>
	);
};

export default DeliverableListItem;
